import { render, staticRenderFns } from "./ConciergeCard.vue?vue&type=template&id=1186ec74"
import script from "./ConciergeCard.vue?vue&type=script&lang=js"
export * from "./ConciergeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports